import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Bmi } from "src/model/Bmi";
import { MeasurementSystem, Units } from "src/utils/enums";

@Component({
  selector: "app-survey-bmi",
  templateUrl: "./survey-bmi.component.html",
  styleUrls: ["./survey-bmi.component.scss"],
  standalone: false
})
export class SurveyBmiComponent implements OnInit, OnDestroy {
  @Input() questionDetails: any;
  @Input() bmiInfo: Bmi;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  feetValid = true;
  inchesValid = true;
  poundsValid = true;
  kilogramsValid = true;
  centimetersValid = true;
  bmiResult: number;
  measurementSystem = MeasurementSystem.Imperial;

  constructor() {
    console.log("Survey BMI component loaded.");
  }

  ngOnInit(): void {
    if (this.questionDetails?.Units){
      if (this.questionDetails?.SelectedAnswer?.AnswerId) {
        this.questionDetails.ShowBmi = true;
        this.bmiInfo = new Bmi();
      }
      if (this.questionDetails.Units.includes(Units.Centimeters) && this.questionDetails.Units.includes(Units.Kilograms)){
        this.measurementSystem = MeasurementSystem.Metric;
        if (this.questionDetails?.kilograms && this.questionDetails?.centimeters){
          this.bmiInfo.kilograms = this.questionDetails.kilograms;
          this.bmiInfo.centimeters = this.questionDetails.centimeters;
        }
      }else{
        this.measurementSystem = MeasurementSystem.Imperial;
        if (this.questionDetails?.pounds && this.questionDetails?.feet && this.questionDetails?.inches){
          this.bmiInfo.feet = this.questionDetails.feet;
          this.bmiInfo.inches = this.questionDetails.inches;
          this.bmiInfo.pounds = this.questionDetails.pounds;
        }
      }
      if (this.questionDetails?.selectedAnswer?.AnswerId) {
        this.bmiResult = this.bmiInfo.calculateBmi(this.measurementSystem);
      }
    }
  }

  ngOnDestroy(): void {
  }

  switchUnits(): void {
    this.clearForm();

    if (this.measurementSystem === MeasurementSystem.Imperial) {
      this.measurementSystem = MeasurementSystem.Metric;
      this.questionDetails.Units = [Units.Centimeters, Units.Kilograms];
    }
    else if (this.measurementSystem === MeasurementSystem.Metric) {
      this.measurementSystem = MeasurementSystem.Imperial;
      this.questionDetails.Units = [Units.Feet, Units.Inches, Units.Pounds];
    }
  }

  clearForm(): void {
    this.bmiResult = null;
    this.bmiInfo = new Bmi();
    this.answerSelectedEvent.emit(null);
  }

  handleInputChange(inputValue: number, unit: Units): void {
    if (!this.validateInput(inputValue, unit)) {
      this.setValidity(false, unit);
      this.bmiResult = null;
      this.answerSelectedEvent.emit(null);
      return;
    }

    this.setValidity(true, unit);

    if (this.bmiInfo.isValid(this.measurementSystem)) {
      this.bmiResult = this.bmiInfo.calculateBmi(this.measurementSystem);
      if(this.measurementSystem === MeasurementSystem.Imperial){
        this.questionDetails.pounds = this.bmiInfo.pounds;
        this.questionDetails.feet = this.bmiInfo.feet;
        this.questionDetails.inches = this.bmiInfo.inches;
      }else{
        this.questionDetails.centimeters = this.bmiInfo.centimeters;
        this.questionDetails.kilograms = this.bmiInfo.kilograms;
      }
      this.answerSelectedEvent.emit(this.bmiInfo.convertToSurveyAnswer(this.questionDetails.Action ? this.questionDetails.Action : ""));
    }
  }

  validateInput(inputValue: number, unit: Units): boolean {
    switch (unit) {
      case Units.Feet:
        return Bmi.validateMeasurementValue(inputValue, Bmi.MinFeet, Bmi.MaxFeet);
      case Units.Inches:
        return Bmi.validateMeasurementValue(inputValue, Bmi.MinInches, Bmi.MaxInches);
      case Units.Pounds:
        return Bmi.validateMeasurementValue(inputValue, Bmi.MinPounds, Bmi.MaxPounds);
      case Units.Centimeters:
        return Bmi.validateMeasurementValue(inputValue, Bmi.MinCentimeters, Bmi.MaxCentimeters);
      case Units.Kilograms:
        return Bmi.validateMeasurementValue(inputValue, Bmi.MinKilograms, Bmi.MaxKilograms);
      default:
        return false;
    }
  }

  setValidity(valid: boolean, unit: Units): void {
    switch (unit) {
      case Units.Feet:
        this.feetValid = valid;
        break;
      case Units.Inches:
        this.inchesValid = valid;
        break;
      case Units.Pounds:
        this.poundsValid = valid;
        break;
      case Units.Centimeters:
        this.centimetersValid = valid;
        break;
      case Units.Kilograms:
        this.kilogramsValid = valid;
        break;
    }
  }
}
